import {
  Popover,
  PopoverProps,
} from "@jugl-web/ui-components/cross-platform/Popover";
import { FC } from "react";
import {
  SelectTaskList,
  SelectTaskListProps,
} from "../SelectTaskList/SelectTaskList";

interface SelectTaskListPopoverProps
  extends SelectTaskListProps,
    Pick<PopoverProps, "placement" | "renderTrigger"> {}

export const SelectTaskListPopover: FC<SelectTaskListPopoverProps> = ({
  placement = "bottom",
  renderTrigger,
  onSelect,
  onRequestCreateTask,
  ...props
}) => {
  return (
    <Popover
      className="z-[2001] w-[375px]"
      placement={placement}
      renderTrigger={renderTrigger}
    >
      {({ onClose }) => (
        <SelectTaskList
          onSelect={(targetTask) => {
            onSelect(targetTask);
            onClose();
          }}
          onRequestCreateTask={
            onRequestCreateTask
              ? () => {
                  onRequestCreateTask();
                  onClose();
                }
              : undefined
          }
          {...props}
        />
      )}
    </Popover>
  );
};
